import { render, staticRenderFns } from "./ChooseOrder.vue?vue&type=template&id=f16ab4d8&scoped=true&"
import script from "./ChooseOrder.vue?vue&type=script&lang=js&"
export * from "./ChooseOrder.vue?vue&type=script&lang=js&"
import style0 from "./ChooseOrder.vue?vue&type=style&index=0&id=f16ab4d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16ab4d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f16ab4d8')) {
      api.createRecord('f16ab4d8', component.options)
    } else {
      api.reload('f16ab4d8', component.options)
    }
    module.hot.accept("./ChooseOrder.vue?vue&type=template&id=f16ab4d8&scoped=true&", function () {
      api.rerender('f16ab4d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/components/inputs/ChooseOrder.vue"
export default component.exports